import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { devOnlyGuard } from './core/guards/dev-only.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: '',
    loadComponent: () => import('./layout/shell/shell.component').then((m) => m.ShellComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'flows',
        loadChildren: () => import('./features/flows/flows.routes').then((m) => m.FLOWS_ROUTES),
      },
      {
        path: 'scenarios',
        loadChildren: () =>
          import('./features/scenarios/scenarios.routes').then((m) => m.SCENARIOS_ROUTES),
      },
      {
        path: 'scenario-routing-rules',
        loadChildren: () =>
          import('./features/scenario-routing-rules/scenario-routing-rules.routes').then(
            (m) => m.SCENARIO_ROUTING_RULES_ROUTES,
          ),
      },
      {
        path: 'shared-components',
        loadChildren: () =>
          import('./features/shared-components/shared-components.routes').then(
            (m) => m.SHARED_COMPONENTS_ROUTES,
          ),
      },
      {
        path: 'template-builder',
        loadChildren: () =>
          import('./features/template-builder/template-builder.routes').then(
            (m) => m.TEMPLATE_BUILDER_ROUTES,
          ),
      },
      {
        path: 'sendgrid-error-intelligence',
        loadChildren: () =>
          import('./features/sendgrid-error-intelligence/sendgrid-error-intelligence.routes').then(
            (m) => m.SENDGRID_ERROR_INTELLIGENCE_ROUTES,
          ),
      },
      {
        path: 'migration',
        canActivate: [devOnlyGuard],
        loadChildren: () =>
          import('./features/migration/migration.routes').then((m) => m.MIGRATION_ROUTES),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
